import { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'

import { GlobalContext } from '../../context/GlobalContext'
import OrdersData from './OrdersData'
import NoOrders from './NoOrders'
import './ListOfOrders.scss'

const ListOfOrders = () => {
  const { t } = useTranslation()
  const [state]: any = useContext(GlobalContext)
  const { rtl, inquiryRes } = state

  const [active, setActive] = useState('enabledButton')
  const [completed, setCompleted] = useState('disabledButton')
  const isActiveEnabled = active === 'enabledButton'
  
  const activeOrCompOrders = inquiryRes.orders.map((order: any) => order.orderInfo.IsOrderActive)
  const hasActiveOrders = activeOrCompOrders.includes('Y')
  const hasCompletedOrders = activeOrCompOrders.includes('N')

  return (
    <div className="listOfOrders_container">
      <div className="listOfOrders_header">
        <Typography className="listOfOrdersScreen_title">{t('your_orders')}</Typography>
        <div className="listOfOrders_buttons">
          <button
            className={active}
            onClick={() => {
              setActive('enabledButton')
              setCompleted('disabledButton')
            }}
          >
            {t('active')}
          </button>
          <button
            className={completed}
            onClick={() => {
              setCompleted('enabledButton')
              setActive('disabledButton')
            }}
          >
            {t('completed')}
          </button>
        </div>
      </div>
      
      <div className="listOfOrders_body">
        <div className="listOfOrders_orders">
          {isActiveEnabled && hasActiveOrders && <OrdersData isOrderActive={'Y'} />}
        </div>

        <div className="listOfOrders_noOrders">
          {isActiveEnabled && !hasActiveOrders && <NoOrders activeEnabled={isActiveEnabled} />}
        </div>

        <div className="listOfOrders_orders">
          {completed === 'enabledButton' && hasCompletedOrders && (
            <OrdersData isOrderActive={'N'} />
          )}
        </div>

        <div className="listOfOrders_noOrders">
          {completed === 'enabledButton' && !hasCompletedOrders && (
            <NoOrders activeEnabled={isActiveEnabled} />
          )}
        </div>
      </div>
    </div>
  )
}

export default ListOfOrders
